exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filterBank{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;max-height:400px;-ms-flex-pack:justify;justify-content:space-between}@media only screen and (max-width: 800px){.filterBank{display:block;max-height:250px;overflow-x:hidden;overflow-y:auto}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/components/FilterBank/style.scss
// module id = 6510
// module chunks = 0